import { useState } from "react";

const ImportDocumentModal = ({
    onClose,
    token,
    idMatch,
    typeClient, // "client" | "donneur_ordre"
    typeDocument,
    onSuccess
}) => {
    const [numero, setNumero] = useState("");
    const [dateEmission, setDateEmission] = useState("");
    const [totalHt, setTotalHt] = useState("");
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);


    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);

        if (!file) {
            setError("Veuillez sélectionner un fichier PDF");
            return;
        }

        const formData = new FormData();
        formData.append("idMatch", idMatch);
        formData.append("typeClient", typeClient);
        formData.append("typeDocument", typeDocument);
        formData.append("dateEmission", dateEmission);
        formData.append("totalHt", totalHt);
        if (numero) formData.append("numeroFacture", numero);
        formData.append("docFile", file);

        try {
            setLoading(true);

            const res = await fetch(
                `${process.env.REACT_APP_API_URL}/api/facturation/import`,
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${token}`
                    },
                    body: formData
                }
            );

            const data = await res.json();

            if (!res.ok) {
                throw new Error(data.error || "Erreur lors de l'import");
            }

            onSuccess?.(data);
            onClose();
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={overlay}>
            <div style={modal}>
                <h2 style={{ marginBottom: "15px" }}>
                    Envoyer un{typeDocument === "devis" ? " devis" : "e facture"}
                </h2>

                <form onSubmit={handleSubmit} style={form}>


                    <input
                        type="text"
                        placeholder="Numéro (optionnel)"
                        value={numero}
                        onChange={(e) => setNumero(e.target.value)}
                    />

                    <input
                        type="date"
                        required
                        value={dateEmission}
                        onChange={(e) => setDateEmission(e.target.value)}
                    />

                    <input
                        type="number"
                        step="0.01"
                        required
                        placeholder="Total HT"
                        value={totalHt}
                        onChange={(e) => setTotalHt(e.target.value)}
                    />

                    <input
                        type="file"
                        accept="application/pdf"
                        required
                        onChange={(e) => setFile(e.target.files[0])}
                    />

                    {error && (
                        <p style={{ color: "red", fontSize: "14px" }}>
                            {error}
                        </p>
                    )}

                    <div style={actions}>
                        <button type="button" onClick={onClose}>
                            Annuler
                        </button>
                        <button type="submit" disabled={loading}>
                            {loading ? "Import..." : "Importer"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

const overlay = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    background: "rgba(0,0,0,0.4)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000
};

const modal = {
    background: "#fff",
    padding: "25px",
    borderRadius: "10px",
    width: "100%",
    maxWidth: "420px"
};

const form = {
    display: "flex",
    flexDirection: "column",
    gap: "12px"
};

const actions = {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    marginTop: "10px"
};


export default ImportDocumentModal;
